module.exports = __webpack_public_path__ + "static/media/bussiness_policy_img2.9e57da26.png";